import {Input} from "./Input.js";
import {InputErrorHandler} from "../../util/input-error-handler/index.js";
import {InputValidator} from "../../util/input-validate/inputValidation.js";

export class PasswordInput extends Input {

    template() {
        const {addClassName = ""} = this.$props;
        return `
            <div class="interactive-form-wrap js-interactive-form-wrap">
                <button id="viewPasswordBtn" type="button" class="password-view-button js-view-button" style=""></button>
                <input id="password"
                    type="password"
                    class="join-password-input js-join-password interactive-form-input ${addClassName}"
                    placeholder=""
                    autocomplete="off"
                    data-required-yn="Y"
                    minlength="8"
                    maxlength="20"
                    data-valid="password"
                    tabindex="2"
                    data-empty-msg="${i18next.t(login.common.enter, {val: $t(dictionary.password)})}"
                    data-over-msg="${i18next.t(login.passwordWarning)}" 
                    data-under-msg="${i18next.t(login.passwordWarning)}" 
                    data-un-valid-msg="${i18next.t(login.passwordWarning)}"
                />
                <span class="interactive-form-placeholder">${i18next.t(dictionary.password)}</span>
            </div>
            <p class="error-txt-wrap">
                <span class="js-error-txt"></span>
            </p>
        `
    }

    setEvent() {
        super.setEvent();
        const isNotWeb = Mutil.isMobile() || Mutil.isTablet();
        if (isNotWeb) {
            this.addEvent("mousedown", "#viewPasswordBtn", this.togglePasswordBtn.bind(this));
            return;
        }

        this.addEvent("mousedown", "#viewPasswordBtn", this.showPassword.bind(this));
        this.addEvent("mouseup", "#viewPasswordBtn", this.hidePassword.bind(this));
    }

    getInputSelector() {
        return "#password";
    }

    togglePasswordBtn() {
        const $viewPasswordBtn = $("#viewPasswordBtn");
        if ($viewPasswordBtn.hasClass("on")) {
            $viewPasswordBtn.removeClass("on");
            this.hidePassword();
            return;
        }
        $viewPasswordBtn.addClass("on");
        this.showPassword();
    }

    showPassword() {
        $(this.getInputSelector()).attr("type", "text");
    }

    hidePassword() {
        $(this.getInputSelector()).attr("type", "password");
    }

    keyUpEventHandlerOfInput(e) {
        const {
            isLast = false,
            submit = Mutil.noop,
            allowBlank = true,
        } = this.$props;

        const input = $(e.target);
        if (Mutil.isAvailableKeyCode(e)) {
            return;
        }
        !allowBlank && InputErrorHandler.removeBlank(input);
        this.togglePasswordViewButton();
        if (!InputValidator.inputValidate(input)) {
            return;
        }

        if (isLast && Mutil.isKey(e, "ENTER")) {
            submit();
            return;
        }
    }

    togglePasswordViewButton() {
        const passwordValue = this.getInputValue();
        const passwordButton = $("#viewPasswordBtn");
        passwordValue.length === 0 ? passwordButton.css("display", "none") : passwordButton.css("display", "block");
    }

}